module.exports = __webpack_public_path__ + "img/25.bde6f7c5.png";